<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Language'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-globe"></p-inputicon>
                <input
                        pInputText
                        id="language-name"
                        [(ngModel)]="this.language.name"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Language Name"
                />
            </p-iconfield>
            <label for="language-name">Language Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-key"></p-inputicon>
                <input
                        pInputText
                        id="locale-key"
                        [(ngModel)]="this.language.localeKey"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Locale Key (e.g., 'en_US')"
                />
            </p-iconfield>
            <label for="locale-key">Locale Key <span class="text-red-500">*</span></label>
        </p-ifta-label>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveLanguage()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>
